import React from "react";

import AllRoutes from "./routers/routes";
import "react-toastify/dist/ReactToastify.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

const App = () => {
  const dynamicTitle = "HUSL";
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{dynamicTitle}</title>
        </Helmet>
        <AllRoutes />
      </HelmetProvider>
    </>
  );
};

export default App;
